var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComingSoonBanner = function SvgComingSoonBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 41,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AB9767",
    d: "M7.875 1.295C3.479 3.727 0 7.886 0 10.71v1.06h20.222l.458 1.647c.765 2.668 3.785 8.475 6.117 11.692 1.185 1.648 3.249 3.963 4.587 5.14 2.37 2.118 7.99 6.238 8.486 6.238.115 0 1.3.51 2.638 1.177 1.338.628 4.128 1.648 6.23 2.236L52.562 41h71.866c68.195 0 72.018-.04 74.923-.706 12.347-2.904 22.019-10.633 27.638-22.05.841-1.726 1.72-3.884 1.988-4.826l.496-1.648h10.283c8.219 0 10.245-.117 10.245-.51 0-.274-.306-1.412-.65-2.471-.841-2.59-3.822-5.572-7.301-7.377L239.297 0H124.732L10.13.04z"
  })));
};
export default SvgComingSoonBanner;